"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          max-width: ", "px;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .DateInput {\n      margin: 0;\n      padding: 0;\n      position: relative;\n      display: inline-block;\n      -moz-appearance: textfield;\n      max-width: ", "px;\n\n      vertical-align: middle;\n    }\n    .DateInput__small {\n      width: 96px;\n      \n    }\n    .DateInput__block {\n      width: 100%;\n      max-width: unset;\n      ", "\n    }\n    .DateInput__disabled {\n      background-color: ", ";\n      color: ", ";\n    }\n    .DateInput_input {\n      box-sizing: border-box;\n      color: ", ";\n      width: 100%;\n      height: 60px;\n      padding: ", "px ", "px;\n      \n      background-color: transparent;\n      border: 0;\n      border-radius: 0;\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n    .DateInput_input__small {\n      font-size: 14px;\n      max-width: ", "px;\n      height: ", "px;\n      font-weight: 600;\n      padding: ", "px ", "px;\n    }\n    .DateInput_input__regular {\n      font-weight: auto;\n    }\n    .DateInput_input__readOnly {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n    }\n    .DateInput_input__focused {\n      outline: 0;\n      /* background: ", ";\n      border-color: ", ";\n      border: 0;\n      border-top: 0;\n      border-right: 0;\n      border-bottom: ", ";\n      border-left: 0; */\n    }\n    .DateInput_input__disabled {\n      background: ", ";\n      font-style: italic;\n    }\n    .DateInput_screenReaderMessage {\n      border: 0;\n      clip: rect(0, 0, 0, 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    }\n    .DateInput_fang {\n      position: absolute;\n      width: ", "px;\n      height: ", "px;\n      left: ", "px;\n      z-index: 2;\n    }\n    .DateInput_fangShape {\n      fill: ", ";\n    }\n    .DateInput_fangStroke {\n      stroke: ", ";\n      fill: transparent;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var dateInput = function dateInput(props) {
  var theme = props.theme,
      width = props.width;
  var palette = theme.palette,
      border = theme.border,
      spacing = theme.spacing;
  return styled_components_1.css(_templateObject(), theme.spacing.unit * 37, width && styled_components_1.css(_templateObject2(), width.toString()), bitcoincom_pkg_theme_1.colors.solid.mystic, bitcoincom_pkg_theme_1.colors.solid.ghostLight, palette.text["default"], spacing.unit * 2, spacing.unit * 3, bitcoincom_pkg_theme_1.colors.solid.ghost, theme.spacing.unit * 15, theme.spacing.unit * 5, theme.spacing.unit, theme.spacing.unit * 1.5, palette.background["default"], palette.primary["default"], border.solid.medium, bitcoincom_pkg_theme_1.colors.solid.mystic, spacing.unit * 3, spacing.unit * 2, spacing.unit * 2, palette.background["default"], palette.border.secondary);
};

exports["default"] = dateInput;